const loadGoogleTagScript = (tagId = 'GTM-N27NNNG') => {
    // eslint-disable-next-line func-names
    (function (w, d, s, l, i) {
        // eslint-disable-next-line no-param-reassign
        w[l] = w[l] || []; w[l].push(
            { 'gtm.start': new Date().getTime(), event: 'gtm.js' }
        ); const f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s);
        // eslint-disable-next-line eqeqeq
        const dl = l != 'dataLayer' ? `&l=${l}` : '';
        j.async = true; j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
        f.parentNode.insertBefore(j, f);
    }(window, document, 'script', 'dataLayer', tagId));
};

export default {
    install: (Vue, options = {}) => {
        const gtmOptions = {
            enabled: true,
            loadScript: true,
            ...options
        };

        window.dataLayer = [];
        if (gtmOptions.enabled && gtmOptions.loadScript) {
            loadGoogleTagScript(gtmOptions.id);
        }

        // eslint-disable-next-line no-param-reassign
        Vue.prototype.$gtm = {
            track: (event) => {
                if (window.dataLayer && gtmOptions.enabled) {
                    window.dataLayer.push({
                        event
                    });
                }
            }
        };
    }
};
